// extracted by mini-css-extract-plugin
module.exports = {"accountNavButton":"w-","menuBackground":"w_","navArrow":"xa","avatar":"xb","userName":"xc","active":"xd","b":"xe","a":"xf"};